import { IS_NEW_BACKEND_API, convertArrayToCamelCase, convertToCamelCase } from '@skytech/utils'

import type { InjuryReport, InjuryReportExtended } from '@/components/injury-reports/types'
import { get, post } from '@/util/auth'

import {
  API_ROUTE_INJURY_REPORT,
  API_ROUTE_INJURY_REPORTS,
  API_ROUTE_INJURY_REPORT_COMMENT,
  API_ROUTE_INJURY_REPORT_SMS,
  API_ROUTE_INJURY_REPORT_STATUS,
} from './apiRoutes'

const injuryReportsResources = {
  get: async (injuryReportId: number) => {
    const injuryReports = await get<Record<string, unknown>>(
      API_ROUTE_INJURY_REPORT.replace(':id', String(injuryReportId))
    )
    const parsedData = convertToCamelCase(injuryReports)

    return parsedData as InjuryReportExtended
  },
  getList: async () => {
    const injuryReports = await get<Record<string, unknown>[]>(API_ROUTE_INJURY_REPORTS)
    const parsedReports = convertArrayToCamelCase(injuryReports)

    return parsedReports as InjuryReport[]
  },

  // Mutations
  setStatus: ({ injuryReportId, statusId }: { injuryReportId: number; statusId: number }) =>
    post(API_ROUTE_INJURY_REPORT_STATUS.replace(':id', String(injuryReportId)), {
      statusId,
    }),
  addComment: ({ injuryReportId, comment }: { injuryReportId: number; comment: string }) =>
    post(API_ROUTE_INJURY_REPORT_COMMENT.replace(':id', String(injuryReportId)), {
      comment,
    }),
  sendSms: ({
    injuryReportId,
    aliasId,
    recipientNumber,
    recipientCountryId,
    message,
  }: {
    injuryReportId: number
    aliasId: number
    recipientNumber: string
    recipientCountryId: number
    message: string
  }) =>
    post(
      API_ROUTE_INJURY_REPORT_SMS.replace(':id', String(injuryReportId)),
      {
        aliasId,
        recipientNumber,
        recipientCountryId,
        message,
      },
      IS_NEW_BACKEND_API
    ),
}

export default injuryReportsResources
